import { render } from "./qxc-header.vue?vue&type=template&id=b5857900&scoped=true"
import script from "./qxc-header.vue?vue&type=script&lang=js"
export * from "./qxc-header.vue?vue&type=script&lang=js"

import "./qxc-header.vue?vue&type=style&index=0&id=b5857900&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5857900"]])

export default __exports__